import { useEffect } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import CategoryGrid from "./components/CategoryGrid";
import AboutSection from "./components/AboutSection";
import FeatureSection from "./components/FeatureSection";
import ComparisonTable from "./components/ComparisonTable";
import BlogPreview from "./components/BlogPreview";
import FAQSection from "./components/FAQSection";
import CTASection from "./components/CTASection";

export default function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <AboutSection />
        <FeatureSection />
        <ComparisonTable />
        <BlogPreview />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}